import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = { class: "flex flex-col w-44 rounded-lg overflow-hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-3 border-b dark:border-gray-900 whitespace-nowrap text-gray-500 font-medium" }, " Select a network ", -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "ml-1 font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, {
    align: "left",
    "no-pad": ""
  }, {
    activator: _withCtx(() => [
      _createVNode(_component_BalBtn, {
        color: "white",
        size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
        class: "ml-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.iconSrc(_ctx.activeNetwork),
            alt: _ctx.activeNetwork.name,
            class: "w-5 h-5 rounded-full shadow-sm"
          }, null, 8, _hoisted_1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.activeNetwork.name), 1),
          _createVNode(_component_BalIcon, {
            name: "chevron-down",
            size: "sm",
            class: "ml-2"
          })
        ]),
        _: 1
      }, 8, ["size"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
          return (_openBlock(), _createElementBlock("a", {
            key: network.id,
            href: _ctx.appUrl(network),
            class: "flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-850"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.iconSrc(network),
                alt: network.name,
                class: "w-5 h-5 rounded-full mr-2"
              }, null, 8, _hoisted_7),
              _createElementVNode("span", _hoisted_8, _toDisplayString(network.name), 1)
            ]),
            (_ctx.isActive(network))
              ? (_openBlock(), _createBlock(_component_BalIcon, {
                  key: 0,
                  name: "check",
                  class: "text-blue-500"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _: 1
  }))
}